// Chakra imports
import { Box, SimpleGrid } from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCourses, setGlobalCourses } from "redux/slices/coursesSlice";
import { getFormations, setFormations } from "redux/slices/formationsSlice";
import { setUsers } from "redux/slices/usersSlice";
import CoursesTable from "views/admin/dataTables/components/CoursesTable";
import FormationsTable from "views/admin/dataTables/components/FormationsTable";
import UsersTable from "views/admin/dataTables/components/UsersTable";
import useTableDataCheck from "views/admin/dataTables/variables/tableDataCheck";
import useUsersTableData from "views/admin/dataTables/variables/tableDataColumns";
import useTableDataComplex from "views/admin/dataTables/variables/tableDataComplex";

export default function Settings() {
  const { formations } = useAppSelector(getFormations);
  const { courses } = useAppSelector(getCourses);
  const dispatch = useAppDispatch();
  const [loadingFormation, setLoadingFormation] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(true);
  React.useEffect(() => {
    const getFormationData = async () => {
      try {
        const res = await axios.get(`${apiurl}/formation`);
        dispatch(setFormations(res.data));
        setLoadingFormation(false);
      } catch (error) {
        console.log(error);
      }
    };
    getFormationData();
  }, [dispatch]);
  React.useEffect(() => {
    const getCoursesData = async () => {
      try {
        const res = await axios.get(`${apiurl}/course`);
        dispatch(setGlobalCourses(res.data));
        console.log({ courses });
        setLoadingCourses(false);
      } catch (error) {
        console.log(error);
      }
    };
    getCoursesData();
  }, [dispatch]);
  React.useEffect(() => {
    const getUsersData = async () => {
      try {
        const res = await axios.get(`${apiurl}/user`);
        dispatch(setUsers(res.data));

        setLoadingUsers(false);
      } catch (error) {
        console.log(error);
      }
    };
    getUsersData();
  }, [dispatch]);
  // Chakra Color Mode
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        {/*<DevelopmentTable   tableData={tableDataDevelopment} />
				<CheckTable tableData={tableDataCheck} />
	<ColumnsTable  tableData={tableDataColumns} />*/}

        <FormationsTable
          loading={loadingFormation}
          tableData={useTableDataComplex()}
        />
        <CoursesTable
          tableData={useTableDataCheck()}
          loading={loadingCourses}
        />
        <UsersTable tableData={useUsersTableData()} loading={loadingUsers} />
      </SimpleGrid>
    </Box>
  );
}
